"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tlds = void 0;
// List of Internet top-level domains
exports.tlds = [
    "africa",
    "agency",
    "app",
    "art",
    "bio",
    "blog",
    "business",
    "camp",
    "capital",
    "church",
    "city",
    "cloud",
    "club",
    "coach",
    "company",
    "consulting",
    "deals",
    "dental",
    "design",
    "dev",
    "digital",
    "direct",
    "dog",
    "eco",
    "email",
    "eus",
    "expert",
    "family",
    "finance",
    "fish",
    "fyi",
    "games",
    "giving",
    "gle",
    "global",
    "group",
    "guru",
    "hamburg",
    "health",
    "help",
    "house",
    "how",
    "icu",
    "law",
    "legal",
    "link",
    "live",
    "llc",
    "marketing",
    "media",
    "mobi",
    "moe",
    "network",
    "ninja",
    "nyc",
    "one",
    "online",
    "page",
    "pink",
    "realtor",
    "reviews",
    "site",
    "social",
    "solar",
    "solutions",
    "space",
    "studio",
    "team",
    "tech",
    "travel",
    "ventures",
    "vip",
    "vision",
    "website",
    "win",
    "works",
    "world",
    "xyz",
];
